export const MISSING_INFO_CONSTANTS = {
  MISMATCH_TEXT: 'Are you sure you want to override?',
  YES: 'Yes',
  NO: 'No',
  SUBMIT: 'Submit',
  CLOSE: 'Close',
  STOPCURRENTFLOW: 'stopCurrentFlow',
  COPAY_MI_TEXT:
    'You can either review the missing fields or if your proceed to MI, the case status will be updated to Missing Information:',
  BV_MI_TEXT:
    'You can either review the missing fields or if you proceed to MI, the case status will be updated to “BV Missing Information”.',
  BV_READY_MSG: 'This case is ready for Benefit Verification (BV)',
  SUCCESS: 'SUCCESS',
  COPAY: 'copay',
  ELIGIBLE: 'ELIGIBLE',
  INELIGIBLE: 'INELIGIBLE',
  MIMISMATCH: 'MIMISMATCH',
  TASK_SUCCESS_MSG: 'Task completed successfully!',
  TASK_ERROR_MSG: 'Something went wrong, could not complete task!',
  MSSING_INFO_PRESENT: 'Please update Missing Information',
  FUNDING_STATUS_NULL: 'FUNDINGSTATUSNULL',
  FALSE: 'FALSE',
  DATA_CHECK_BUTTON: 'Proceed with Data Check Process',
}
